import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
    .use(Backend) // Load translations from a file
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Bind i18n to React
    .init({
        lng: 'zh-CN', // Set default language to Chinese
        fallbackLng: 'zh-CN', // Default language if detection fails
        debug: true, // Enable debug mode
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
    });

export default i18n;
